/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { rpMediaQueries } from 'core/theme'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useRussianPokerStore } from '../../providers/RussianPokerProvider'
import BoxDealer from '../BoxDealer'
import DecisionBox from '../DecisionBox'

const DecisionPanel: FC<{
  className?: string
}> = observer(({ className }) => {
  const { boxes } = useRussianPokerStore()
  return (
    <div
      className={className}
      css={css`
        align-items: self-end;
        flex-direction: column;
        display: flex;
        gap: 4px;

        ${rpMediaQueries.tablet} {
          gap: 8px;
        }
      `}>
      <BoxDealer />
      {boxes
        .filter((box) => box.hasStake || box.result.outcome !== 'none')
        .map((box) => (
          <DecisionBox box={box} key={box.seatNumber} />
        ))}
    </div>
  )
})

export default DecisionPanel
